import { IUpdateNovosNegociosArquivoUseCase } from "../../../presentation/useCases/update/update_novos_negocios_arquivo_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateNovosNegociosArquivoUseCase
 */

export class UpdateNovosNegociosArquivoUseCase implements IUpdateNovosNegociosArquivoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idNovosNegociosArquivo: number,
    idNovosNegocios?: number,
    arquivo?: File,
    descricao?: string,
    limparArquivo?: boolean,

  ): Promise<void> {
    const computedArquivoNome = limparArquivo ? null : arquivo?.name;
    const computedArquivo = limparArquivo ? null : arquivo;

    await this.repository.updateNovosNegociosArquivo(
      idNovosNegociosArquivo,
      idNovosNegocios,
      computedArquivoNome ? computedArquivoNome : undefined,
      descricao ?? undefined,
      computedArquivo ? computedArquivo : undefined,

      limparArquivo ?? false,

    );
  }
}
